"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showFullScreenLoader;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _styles = require("./styles");

var _Loader = _interopRequireDefault(require("../Loader"));

function showFullScreenLoader() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var container = document.createElement('div');
  document.body.appendChild(container);

  function hideLoader() {
    (0, _reactDom.unmountComponentAtNode)(container);
    container.parentNode && container.parentNode.removeChild(container);
  }

  var className = props.className;
  (0, _reactDom.render)(_react.default.createElement(_emotionTheming.ThemeProvider, {
    theme: _themeConfig.default
  }, _react.default.createElement(_styles.RootContainer, {
    className: className
  }, _react.default.createElement(_Loader.default, null))), container);
  return {
    hideLoader: hideLoader
  };
}